import {
  GET_COLLECTION_RECORDS,
  GET_COLLECTION_RECORDS_SUCCESS,
  GET_COLLECTION_RECORDS_ERROR,
  GET_CART_LINKS,
  GET_CART_LINKS_SUCCESS,
  GET_CART_LINKS_ERROR
} from "../actions";

export const getCollectionItemRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount) => ({
  type: GET_COLLECTION_RECORDS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount },
});

export const getCollectionItemRecordsSuccess = (recordCollectionItemList) => ({
  type: GET_COLLECTION_RECORDS_SUCCESS,
  payload: recordCollectionItemList,
});

export const getCollectionItemRecordsError = (message) => ({
  type: GET_COLLECTION_RECORDS_ERROR,
  payload: { message },
});

export const getCartLinks = () => ({
  type: GET_CART_LINKS,
  payload: {},
});

export const getCartLinksSuccess = (cartLinks) => ({
  type: GET_CART_LINKS_SUCCESS,
  payload: cartLinks,
});

export const getCartLinksError = (message) => ({
  type: GET_CART_LINKS_ERROR,
  payload: { message },
});
